export default "__VITE_ASSET__CDy1Ts8e__"